import React, { useEffect } from "react";
// import RequestsDatatable from "../components/datatables/RequestsDatatable";
import PageLayout from "@/Themes/Default/Layouts/PageLayout";
import '@/Styles/datatables.scss';
import ReportsDatatable from "@/Components/Datatables/ReportsDatatable";

/**
 * Reports page
 */
const ReportsPage = () => {
    useEffect(() => {
        document.title = 'Reports' + ' · ' + document.title;
    }, []);

    return (
        <PageLayout>
            <ReportsDatatable />
        </PageLayout>
    );
};

export default ReportsPage;